import { Button, Card, Col, Flex, Form, Input, Modal, Row, Select } from "antd";
import React from "react";
import { CustomTitle } from "../../../../common/customTitle";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import { sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import {
  createFaqAction,
  getFaqByIdAction,
  updateFaqAction,
} from "../../../../../redux/services/faqs/faqsServices";
import { useEffect } from "react";
import Actions from "../../../../../redux/actions";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";

const FaqsFormDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedFaqId } = useSelector((state) => state.faqs);
  /* id dependencies */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedFaqId &&
      selectedFaqId !== "" &&
      selectedFaqId !== null &&
      selectedFaqId !== undefined
    ) {
      const dataToBeSent = {
        selectedFaqId,
      };
      setLoading(true);
      dispatch(getFaqByIdAction(dataToBeSent)).then((apiRes) => {
        const locale = apiRes.locales[0];
        form.setFieldsValue({
          question: apiRes?.question || "",
          answer: apiRes?.answer || "",
          question_ar: locale?.question || "",
          answer_ar: locale?.answer || "",
          faq_for: apiRes?.faq_for,
        });

        setLoading(false);
      });
    }
    /* initial dependencies - Edit */
  }, [open]);

  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
    dispatch(
      Actions.createAction(Actions.SELECTED_FAQ_ID, { selectedFaqId: "" })
    );
    dispatch(Actions.createAction(Actions.GET_FAQ_BY_ID, { faq: {} }));
  };
  /* dialog close dependencies */

  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
    };
    if (
      selectedFaqId &&
      selectedFaqId !== "" &&
      selectedFaqId !== null &&
      selectedFaqId !== undefined
    ) {
      dataToBeSent._id = selectedFaqId;
      dispatch(updateFaqAction(dataToBeSent)).then(() => {
        handleDialogClose();
      });
    } else {
      dispatch(createFaqAction(dataToBeSent)).then(() => {
        handleDialogClose();
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      style={{ top: 20 }}
    >
      <CustomTitle textDecoration="underline" justifyContent="center">
        {!selectedFaqId ||
        selectedFaqId === "" ||
        selectedFaqId === null ||
        selectedFaqId === undefined
          ? t("AppModuleNames.SuperAdmin.ADDFAQS")
          : t("AppModuleNames.SuperAdmin.EDITFAQS")}
      </CustomTitle>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        style={{ margin: "2rem" }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="faq_for"
              label={
                <RequiredLabel
                  text={t("Modules.Configuration.userType")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Configuration.pleaseSelectUserType"),
                },
              ]}
            >
              <Select
                loading={selectListLoader}
                options={[
                  { value: "Customer", label: "User" },
                  { value: "Organization", label: "Service Provider" },
                ]}
                placeholder={t("Modules.Configuration.selectUserType")}
              />
            </Form.Item>
          </Col>
        </Row>

        <Card bordered>
          <Form.Item
            style={{ width: "100%" }}
            name="question"
            label={
              <RequiredLabel
                text={t("Modules.FaqsRevenue.question")}
                required={true}
              />
            }
            rules={[
              {
                required: true,
                message: t("Modules.FaqsRevenue.pleaseEnterQuestion"),
              },
              {
                whitespace: true,
                message: t("Modules.FaqsRevenue.questionCannotBeEmpty"),
              },
            ]}
            normalize={(value) => sanitizeDataTypeClientSide(value)}
          >
            <Input placeholder={t("Modules.FaqsRevenue.enterQuestion")} />
          </Form.Item>
          <Form.Item
            style={{ width: "100%"}}
            name="question_ar"
            label={
              <RequiredLabel
                text={`${t("Modules.FaqsRevenue.question")} ${t("CommonUtils.inArabic")}`}
                required={true}
              />
            }
            rules={[
              {
                required: true,
                message: `${t("Modules.FaqsRevenue.pleaseEnterQuestion")} ${t("CommonUtils.inArabic")}`,
              },
              {
                whitespace: true,
                message: `${t("Modules.FaqsRevenue.questionCannotBeEmpty")} ${t("CommonUtils.inArabic")}`,
              },
            ]}
            normalize={(value) => sanitizeDataTypeClientSide(value)}
          >
            <Input
              dir="rtl"
              placeholder={`${t("Modules.FaqsRevenue.enterQuestion")} ${t("CommonUtils.inArabic")}`}
            />
          </Form.Item>

          <Form.Item
            label={
              <RequiredLabel
                text={t("Modules.FaqsRevenue.answer")}
                required={true}
              />
            }
            name="answer"
            rules={[
              {
                required: true,
                message: t("Modules.FaqsRevenue.pleaseEnterAnswer"),
              },
              {
                whitespace: true,
                message: t("Modules.FaqsRevenue.answerCannotBeEmpty"),
              },
            ]}
            normalize={(value) => sanitizeDataTypeClientSide(value)}
          >
            <TextArea
              rows={4}
              showCount
              maxLength={appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA}
              placeholder={t("Modules.FaqsRevenue.enterAnswer")}
            />
          </Form.Item>
          <Form.Item
            label={
              <RequiredLabel
                text={`${t("Modules.FaqsRevenue.answer")} ${t("CommonUtils.inArabic")}`}
                required={true}
              />
            }
            name="answer_ar"
            rules={[
              {
                required: true,
                message: `${t("Modules.FaqsRevenue.pleaseEnterAnswer")} ${t("CommonUtils.inArabic")}`,
              },
              {
                whitespace: true,
                message: `${t("Modules.FaqsRevenue.answerCannotBeEmpty")} ${t("CommonUtils.inArabic")}`,
              },
            ]}
            normalize={(value) => sanitizeDataTypeClientSide(value)}
          >
            <TextArea
              dir="rtl"
              rows={4}
              showCount
              maxLength={appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA}
              placeholder={t("Modules.FaqsRevenue.enterAnswer")}
            />
          </Form.Item>
        </Card>
        <Flex gap="1rem" align="center" justify="center">
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: "1rem" }}
            loading={loading}
            disabled={loading}
          >
            {t("CommonUtils.submit")}
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};

export default FaqsFormDialog;
